import PropTypes from 'prop-types'

function BtnActionLink(props){
    return(
        <div className={`button-link action-link ${props.type}`} href={props.href} onClick={props.action}>
            <p>{props.text}</p>
            {props.icon && <span className={`fa ${props.icon}`}></span>}
        </div>
    )
}

BtnActionLink.propTypes = {
    href: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['primary', 'secondary', 'primary largeBtn', 'secondary largeBtn']).isRequired,
    action: PropTypes.func.isRequired,
    icon: PropTypes.string
}

export default BtnActionLink;